import { STATUSPAGE } from '@repo/ui';
import { GetAllCHMetricsResponse } from 'domain/models';
import Skeleton from 'react-loading-skeleton';
import { useSelector } from 'react-redux';
import { Card, CardBody, Col, Row } from 'reactstrap';
import { createSelector } from 'reselect';

interface IProps {
  data: GetAllCHMetricsResponse | undefined;
  statusCH: STATUSPAGE;
}

export const WidgetsCH = ({ data, statusCH }: IProps) => {
  const layout = createSelector(
    (state) => state.Layout,
    (layoutModeType) => layoutModeType.layoutModeType,
  );
  const layoutModeType = useSelector(layout);

  const widgetsData = [
    {
      label: 'CH Realizada',
      value: data?.completed ?? '00h 00m',
      icon: 'ri-calendar-2-line',
      color: 'info',
    },
    {
      label: 'CH Validada',
      value: data?.validated ?? '00h 00m',
      icon: 'ri-calendar-check-line',
      color: 'success',
    },
    {
      label: 'CH Rejeitada',
      value: data?.rejected ?? '00h 00m',
      icon: 'ri-calendar-close-line',
      color: 'danger',
    },
    {
      label: 'CH Pendente',
      value: data?.pending ?? '00h 00m',
      icon: 'ri-hourglass-fill',
      color: 'warning',
    },
  ];

  return (
    <Row className="mt-4">
      {widgetsData.map((item, index) => (
        <Col xl={3} md={6} key={index}>
          <Card
            className={`bg-${layoutModeType === 'dark' ? 'light' : item.color}`}
          >
            <CardBody>
              <div className="d-flex align-items-center m-2">
                <div className="flex-grow-1">
                  <h4 className="fs-4 text-white">
                    <span className="counter-value">
                      {statusCH === STATUSPAGE.LOADING ? (
                        <Skeleton width={80} />
                      ) : (
                        item.value
                      )}
                    </span>
                  </h4>
                  <span className="fw-normal text-white">{item.label}</span>
                </div>

                <div className="flex-shrink-0">
                  <h1 className="text-white">
                    <i className={item.icon}></i>{' '}
                  </h1>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </Row>
  );
};
